import { Role } from '@guiker/permissions'

import { BackgroundCheckActions } from '../background-check-actions'
import { BackgroundCheckRoleNames } from '../role-names'

export const ApplicantRole: Role = {
  name: BackgroundCheckRoleNames.APPLICANT,
  permissions: [{ action: BackgroundCheckActions.ViewBackgroundCheck }],
}
